import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';

const JiraAgenticSummaryViewRelayProvider = {
	get(): boolean {
		// Killswitch: if off, skip the experiment check and suppress the rovoEnablementStatus fetch
		// entirely, mirroring the killswitch guard in useIsAgenticSummaryView.
		if (!fg('jira_agentic_summary_view_killswitch')) {
			return false;
		}
		// No-exposure check: gates whether `rovoEnablementStatus` is fetched for the agentic summary
		// tab. Exposure is fired at the point the agentic summary view actually renders, not here.
		return UNSAFE_noExposureExp('jira_agentic_summary_view')[0].get('isEnabled', false);
	},
};

export default JiraAgenticSummaryViewRelayProvider;
